(()=>{
  'use strict';
  if(window.__SOCH_DOST_MOBILE_UX__) return;
  window.__SOCH_DOST_MOBILE_UX__=true;

  const initialiseHeroSwipe=(scope=document)=>{
    const roots=[];
    if(scope.matches?.('[data-hero-slideshow]')) roots.push(scope);
    roots.push(...scope.querySelectorAll?.('[data-hero-slideshow]')||[]);

    roots.forEach((root)=>{
      if(root.dataset.sdSwipeReady==='true') return;
      root.dataset.sdSwipeReady='true';

      const slides=[...root.querySelectorAll('[data-hero-slide]')];
      if(slides.length<2) return;

      let startX=null;
      let startY=null;
      let startedOnControl=false;

      const move=(direction)=>{
        const selector=direction>0?'[data-hero-next]':'[data-hero-prev]';
        const arrow=root.querySelector(selector);
        if(arrow){
          arrow.click();
          return;
        }

        const active=Math.max(0,slides.findIndex((slide)=>slide.classList.contains('is-active')));
        const next=(active+direction+slides.length)%slides.length;
        const dots=[...root.querySelectorAll('[data-hero-dot]')];
        if(dots[next]) dots[next].click();
      };

      root.addEventListener('touchstart',(event)=>{
        if(event.touches.length!==1) return;
        startedOnControl=Boolean(event.target.closest('a,button,input,select,textarea,label'));
        if(startedOnControl) return;
        startX=event.touches[0].clientX;
        startY=event.touches[0].clientY;
      },{passive:true});

      root.addEventListener('touchend',(event)=>{
        if(startedOnControl||startX===null||!event.changedTouches.length){
          startX=null;
          startY=null;
          startedOnControl=false;
          return;
        }

        const dx=event.changedTouches[0].clientX-startX;
        const dy=event.changedTouches[0].clientY-startY;
        startX=null;
        startY=null;
        startedOnControl=false;

        if(Math.abs(dx)>=42&&Math.abs(dx)>Math.abs(dy)*1.15){
          move(dx<0?1:-1);
        }
      },{passive:true});

      root.addEventListener('touchcancel',()=>{
        startX=null;
        startY=null;
        startedOnControl=false;
      },{passive:true});
    });
  };

  const boot=()=>initialiseHeroSwipe(document);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();

  document.addEventListener('shopify:section:load',(event)=>initialiseHeroSwipe(event.target));
})();
